import {uniqBy} from "lodash";

function inferDragType(node, explicitType) {
    if (explicitType === 'group' || explicitType === 'device') return explicitType
    if (node && Array.isArray(node.children)) return 'group'
    return 'device'
}

function parseDragData(e, preferredType) {
    const candidateTypes = [
        preferredType,
        preferredType === 'group' ? 'device' : 'group',
        'application/json',
        'text/plain'
    ]
    for (const type of candidateTypes) {
        if (!type) continue
        const raw = e.dataTransfer.getData(type)
        if (!raw) continue
        try {
            return JSON.parse(raw)
        } catch (_ignored) {
            // Continue trying alternative MIME types.
        }
    }
    return null
}

export const dropHandler = (e, managedNode, itemDroppedCallback, handleDragExit, selectedNodeList) => {
    let type = e.dataTransfer.types.includes('group') ? 'group' : 'device';
    if (type === "group" || selectedNodeList.length <= 1) {
        // There was an error here, so logging some more
        // see https://airmaster-as.sentry.io/issues/4026854769/?alert_rule_id=11952736&alert_timestamp=1679479920122&alert_type=email&environment=prod&project=6654519&referrer=alert_email
        const parsedData = parseDragData(e, type)
        if (!parsedData) {
            throw Error(JSON.stringify({
                message: `e.dataTransfer.getData(type) was falsy, see error`,
                type: type,
                dataTransfer: e.dataTransfer,
                data: null,
                e, managedNode, itemDroppedCallback, handleDragExit, selectedNodeList
            }))
        }
        itemDroppedCallback(parsedData, managedNode)
    } else {
        const draggedNode = parseDragData(e, type)
        if (!draggedNode) {
            throw Error(JSON.stringify({
                message: `Drag data could not be parsed for multi-select drop`,
                type: type,
                dataTransfer: e.dataTransfer,
                e, managedNode, itemDroppedCallback, handleDragExit, selectedNodeList
            }))
        }
        const data = uniqBy([draggedNode, ...selectedNodeList.filter(n => n.type === 'device')], 'id')
        itemDroppedCallback(data, managedNode)
    }
    handleDragExit(e)
}

export const toggleGrabbingCursor = (eleRef) => {
    if (eleRef.current.classList.contains("cu-grabbing")) {
        eleRef.current.classList.remove("cu-grabbing")
        eleRef.current.classList.add("cu-grab")
    } else {
        eleRef.current.classList.remove("cu-grab")
        eleRef.current.classList.add("cu-grabbing")
    }
}
export const toggleEditStyles = (isDraggable, selectRef, allowDrag = true) => {
    if (isDraggable) {
        allowDrag && selectRef.current.classList.add('cu-grab')
        selectRef.current.classList.add('active-hover-effect')
    } else {
        allowDrag && selectRef.current.classList.remove('cu-grab')
        selectRef.current.classList.remove('active-hover-effect')
        selectRef.current.classList.add('cursor-pointer', 'hover-effect')
    }
}
export const dragStartEventHandler = (e, node, selectRef, type) => {
    toggleGrabbingCursor(selectRef)
    const dragType = inferDragType(node, type)
    const payload = JSON.stringify(node)
    e.dataTransfer.setData(dragType, payload)
    e.dataTransfer.setData('application/json', payload)
    e.dataTransfer.setData('text/plain', payload)
}